<template>
  <div class="case-main">
    <div class="banner" v-if="deviceType == 'pc'"><div class="w"></div></div>
    <img src="../../assets/images/home/alzx.png" alt="" v-else />
    <div class="map w">
      <div class="title"></div>
      <div class="map_left">
        <img class="icon" :src="require('@/assets/images/case-map.png')" />
      </div>
      <div class="map_right">
        <div class="one">
          <div class="info-title">15<span class="unit">省+</span></div>
          <div class="desc">合作15省</div>
        </div>
        <div class="two">
          <div class="info-title">50 <span class="unit">地市+</span></div>
          <div class="desc">合作50地市</div>
        </div>
        <div class="three">
          <div class="info-title">580 <span class="unit">区县+</span></div>
          <div class="desc">合作580区县</div>
        </div>
        <div class="four">
          <div class="info-title">65000 <span class="unit">客户+</span></div>
          <div class="desc">服务65000家政府机关、事业单位客户</div>
        </div>
        <div class="five">
          <span class="desc"
            >鼎欣科技发展至今已与15个省份（江西省、青海省、西藏自治区、海南省、广西省、山西省、湖南省、湖北省、浙江省、江苏省、云南省、河北省、贵州省、宁夏自治区、重庆市），40多个地市及500多个县区合作，服务65000家政府机关、事业单位客户。</span
          >
        </div>
      </div>
    </div>
    <div class="subnav">
      <div class="case_main w">
        <div class="notice">
          <div class="notice-topic">
            <h2
              :class="typeActive === item.id ? 'active' : ''"
              v-on:mouseover="MouseOver(item)"
              @click="clickType(item)"
              v-for="(item, i) in typeList"
              :key="i"
            >
              {{ item.title }}
            </h2>
          </div>
          <div class="notice-tab">
            <ul class="ul-logo" v-show="typeActive === '1'">
              <li v-for="(item, i) in imgData" :key="i + item.url">
                <img :src="require(`@/assets/images/case/${item.url}`)" />
              </li>
            </ul>
            <ul class="notice-ul" v-show="typeActive === '2'">
              <div
                class="notice-item"
                v-for="(item, i) in pageData"
                :key="i + item.title"
                :title="item.title"
              >
                <span class="scroll-text">{{ item.title }}</span>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination_box" v-show="typeActive === '2'">
      <el-pagination
        background
        @current-change="currentChange"
        layout="prev, pager, next"
        :current-page="queryParam.page"
        :total="queryParam.total"
      >
      </el-pagination>
    </div>
    <blockSidebar />
  </div>
</template>
<script>
import(
  `@/assets/css/${
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
      ? 'mobile'
      : 'pc'
  }/case.scss`
)
import blockSidebar from '@/components/block-sidebar'
export default {
  // 案例
  components: { blockSidebar },
  computed: {
    deviceType() {
      return this.$store.state.app.deviceType
    },
  },
  data() {
    return {
      queryParam: {
        page: 1,
        pageSize: 72,
        total: 0,
      },
      imgData: [
        {
          url: 'logo-huawei.png',
        },
        {
          url: 'logo-ali.jpg',
        },
        {
          url: 'logo-tx.jpg',
        },
        {
          url: 'logo-4.png',
        },
        {
          url: 'logo-8.png',
        },
        {
          url: 'logo-trx.png',
        },
        {
          url: 'logo-baidu.png',
        },
        {
          url: 'logo-2.png',
        },
        {
          url: 'logo-7.png',
        },
        {
          url: 'logo-10.png',
        },
        {
          url: 'logo-9.jpg',
        },
        {
          url: 'logo-zgdx.jpg',
        },
        {
          url: 'logo-zgyd.png',
        },
        {
          url: 'logo-bryc.png',
        },
        {
          url: 'logo-1.jpg',
        },
        {
          url: 'logo-gnxy.png',
        },
        {
          url: 'logo-6.png',
        },
        {
          url: 'logo-5.png',
        },
        {
          url: 'logo-lc.png',
        },
        {
          url: 'logo-sxf.png',
        },
        {
          url: 'logo-jg.jpg',
        },
        {
          url: 'logo-zy.png',
        },
        {
          url: 'logo-jxny.png',
        },
        {
          url: 'logo-jxns.png',
        },
        {
          url: 'logo-jjyh.jpg',
        },
        {
          url: 'logo-zgyz.png',
        },
        {
          url: 'logo-jxyh.gif',
        },
        {
          url: 'logo-hnfgw.jpg',
        },
        {
          url: 'logo-jxfgw.jpg',
        },
        {
          url: 'logo-dt.png',
        },
        {
          url: 'logo-sxfgw.jpg',
        },
        {
          url: 'logo-jiangjin.jpg',
        },
        {
          url: 'logo-yingtan.jpg',
        },
        {
          url: 'logo-gxjm.png',
        },
        {
          url: 'logo-jxjs.png',
        },
        {
          url: 'logo-ytgx.png',
        },
        {
          url: 'logo-cdyxy.png',
        },
        {
          url: 'logo-jxrlzy.png',
        },
        {
          url: 'logo-qhrlzy.png',
        },
        {
          url: 'logo-gxrlzy.png',
        },
        {
          url: 'logo-xzrlzy.png',
        },
        {
          url: 'logo-ncrlzy.png',
        },
        {
          url: 'logo-nxrlzy.png',
        },
        {
          url: 'logo-ncgxq.png',
        },
        {
          url: 'logo-js.png',
        },
        {
          url: 'logo-81jyg.png',
        },
        {
          url: 'logo-jxsjs.png',
        },
        {
          url: 'logo-jxspf.png',
        },
        {
          url: 'logo-ncbwg.png',
        },
        {
          url: 'logo-ncd9.jpg',
        },
        {
          url: 'logo-ncdsyy.png',
        },
        {
          url: 'logo-ncgxj.png',
        },
        {
          url: 'logo-ncgzw.png',
        },
        {
          url: 'logo-ncjkzx.png',
        },
        {
          url: 'logo-ncjyj.png',
        },
        {
          url: 'logo-nckej.png',
        },
        {
          url: 'logo-ncrmzf.png',
        },
        {
          url: 'logo-ncshszh.jpg',
        },
        {
          url: 'logo-nctsg.gif',
        },
        {
          url: 'logo-nctyj.png',
        },
        {
          url: 'logo-ncxz.jpg',
        },
        {
          url: 'logo-jxshkxy.png',
        },
        {
          url: 'logo-nchdzyy.gif',
        },
        {
          url: 'logo-ncgb.png',
        },
        {
          url: 'logo-nczgh.png',
        },
      ],
      typeList: [
        {
          id: '1',
          title: '战略伙伴&重点客户',
        },
        {
          id: '2',
          title: '客户列表',
        },
      ],
      typeActive: '1',
      dataList: [
        { title: '丁青县人力资源和社会保障局' },
        { title: '丁青县教育局' },
        { title: '万宁市人民政府' },
        { title: '上饶市横峰县人民医院' },
        { title: '上饶市横峰县城市管理局' },
        { title: '上饶市横峰县民政局' },
        { title: '中共拉萨市委党校' },
        { title: '中共江西省委党校' },
        { title: '中共江西省委办公厅' },
        { title: '中共江西省委员会组织部' },
        { title: '中共江西省委政法委员会' },
        { title: '中共江西省委政策研究室' },
        { title: '中共江西省委机要局' },
        { title: '中共银川市委宣传部' },
        { title: '中共青海省委办公厅' },
        { title: '中卫市人社局' },
        { title: '中卫市沙坡头区人民医院' },
        { title: '中宁县人社局' },
        { title: '临湘市人民医院' },
        { title: '临湘市人社局' },
        { title: '临湘市教育局' },
        { title: '亚东县人社局' },
        { title: '仲巴县人社局' },
        { title: '八宿县人力资源和社会保障局' },
        { title: '兴庆区人社局' },
        { title: '利通区人社局' },
        { title: '南丰县中医院' },
        { title: '南丰县交通局' },
        { title: '南丰县人民医院' },
        { title: '南丰县人社局' },
        { title: '南丰县农业局' },
        { title: '南丰县林业局' },
        { title: '南丰县桑田中学' },
        { title: '南丰县水利局' },
        { title: '南丰县皮肤医院' },
        { title: '南昌市国土资源局新建分局' },
        { title: '南昌市新建区中医医院' },
        { title: '南昌市新建区人民医院' },
        { title: '南昌市新建区博物馆' },
        { title: '南昌市新建区城市防洪管理局' },
        { title: '南昌市新建区松湖镇人民政府' },
        { title: '南昌市湾里中医院' },
        { title: '南昌市第二中西医结合医院' },
        { title: '南昌市第八人民医院' },
        { title: '南昌市第六医院' },
        { title: '南昌市第十二医院' },
        { title: '南昌市第四医院' },
        { title: '中共南昌市委党校' },
        { title: '中共南昌市委组织部' },
        { title: '南昌仲裁委员会' },
        { title: '南昌市不动产登记中心' },
        { title: '南昌市中西医结合医院' },
        { title: '南昌市交通运输局' },
        { title: '南昌市人民政府办公厅' },
        { title: '南昌市人民检察院' },
        { title: '南昌市体育局' },
        { title: '南昌市八一起义纪念馆' },
        { title: '南昌市公共资源交易中心' },
        { title: '南昌市公路管理局' },
        { title: '南昌市农业局' },
        { title: '南昌市农业科学院' },
        { title: '南昌市动物疫病预防控制中心' },
        { title: '南昌市南昌县八一乡乡政府' },
        { title: '南昌市南昌县公共资源交易中心' },
        { title: '南昌市南昌县农业局' },
        { title: '南昌市南昌县农保局' },
        { title: '南昌市南昌县医保局' },
        { title: '南昌市南昌县向塘镇开发区管委会' },
        { title: '南昌市南昌县富山乡政府' },
        { title: '南昌市南昌县广福镇人民政府' },
        { title: '南昌市南昌县总工会' },
        { title: '南昌市南昌县民政局' },
        { title: '南昌市南昌县泾口乡乡政府' },
        { title: '南昌市南昌县环保局' },
        { title: '南昌市南昌县畜牧水产局' },
        { title: '南昌市南昌县红十字会' },
        { title: '南昌市南昌县网络信息研究中心' },
        { title: '南昌市南昌县财政局' },
        { title: '南昌市博物馆' },
        { title: '南昌市卫生局' },
        { title: '南昌市国土资源局' },
        { title: '南昌市国资委' },
        { title: '南昌市图书馆' },
        { title: '南昌市地产交易中心' },
        { title: '南昌市工信局' },
        { title: '南昌市总工会' },
        { title: '南昌市按摩医院' },
        { title: '南昌市教育局' },
        { title: '南昌市文联' },
        { title: '南昌市新华医院' },
        { title: '南昌市新建区交通运输局' },
        { title: '南昌市新建区人力资源和社会保障局' },
        { title: '南昌市新建区住房和城乡规划建设局' },
        { title: '南昌市新建区农业局' },
        { title: '南昌市新建区农业机械管理局' },
        { title: '南昌市新建区工信委' },
        { title: '南昌市新建区教育体育局' },
        { title: '南昌市新建区松湖镇人民政府' },
        { title: '南昌市新建区林业局' },
        { title: '南昌市新建区水务局' },
        { title: '南昌市新建区环境保护局' },
        { title: '南昌市新建区粮食局' },
        { title: '南昌市新建区财政局' },
        { title: '南昌市旅游局' },
        { title: '南昌市机关事务管理局' },
        { title: '南昌市民俗博物馆' },
        { title: '南昌市民政局' },
        { title: '南昌市气象局' },
        { title: '南昌市水务局' },
        { title: '南昌市洪都中医院' },
        { title: '南昌市湾里人民广播电台' },
        { title: '南昌市湾里区图书馆' },
        { title: '南昌市湾里区文化馆' },
        { title: '南昌市湾里区电影发行放映公司' },
        { title: '南昌市湾里广播电视台' },
        { title: '南昌市物价局' },
        { title: '南昌市环保局' },
        { title: '南昌市疾控中心' },
        { title: '南昌市科技局' },
        { title: '南昌市第一医院' },
        { title: '南昌市第三医院' },
        { title: '南昌市第九医院' },
        { title: '南昌市统计局' },
        { title: '南昌市职工科技大学' },
        { title: '南昌市行政服务中心管理委员会' },
        { title: '南昌市血站' },
        { title: '南昌市规划设计研究院' },
        { title: '南昌市青云谱区发改委' },
        { title: '南昌市青云谱区人社局' },
        { title: '南昌市青云谱区疾病预防控制中心' },
        { title: '南昌市青云谱区科技和工业信息化局' },
        { title: '南昌市青云谱区统计局' },
        { title: '南昌市青山湖区图书馆' },
        { title: '南昌师范高等专科学校' },
        { title: '南昌市青山湖区民政局' },
        { title: '南昌广播电视台' },
        { title: '南昌急救中心' },
        { title: '南昌教育学院' },
        { title: '南昌日报社' },
        { title: '南昌社会科学院' },
        { title: '南昌经济技术开发区人力资源和社会保障局' },
        { title: '南昌经济技术开发区城市管理局' },
        { title: '南昌经济技术开发区劳动监察局' },
        { title: '南昌经济技术开发区安全生产监督管理局' },
        { title: '南昌经济技术开发区招商局' },
        { title: '南昌经济技术开发区社会发展局' },
        { title: '南昌经济技术开发区纪工委' },
        { title: '南昌经济技术开发区经济贸易发展局' },
        { title: '南昌经济技术开发区蛟桥镇医院' },
        { title: '南昌经济技术开发区行政服务中心管理委员会' },
        { title: '南昌经济技术开发区蛟桥镇敬老院' },
        { title: '南昌经济技术开发区规划建设局' },
        { title: '南昌经济技术开发区财政局' },
        { title: '南昌高新区公共人才就业服务局' },
        { title: '南昌高新区教育事业管理中心' },
        { title: '南昌高新区管委会人社局' },
        { title: '南昌高新技术开发区乡镇财政管理局' },
        { title: '江西桑海经济技术开发区房屋产权交易中心' },
        { title: '江西桑海经济技术开发区森林消防队' },
        { title: '江西省皮肤病专科医院' },
        { title: '江西省精神病院' },
        { title: '江西东华计量测试研究所' },
        { title: '江西中医学院' },
        { title: '江西中医药大学附属医院' },
        { title: '江西九岭山国家级自然保护区管理局' },
        { title: '江西交通职业技术学院' },
        { title: '江西交通运输工程档案馆' },
        { title: '江西人民广播电台' },
        { title: '江西信息台' },
        { title: '江西信息应用职业技术学院' },
        { title: '江西农业大学' },
        { title: '江西农业工程职业学院' },
        { title: '江西制造职业技术学院' },
        { title: '江西加扰卫星电视管理中心' },
        { title: '江西司法警官职业学院' },
        { title: '江西地质矿产资源勘查开发中心' },
        { title: '江西地质科学研究所' },
        { title: '江西外语外贸职业学院' },
        { title: '江西工业工程职业技术学院' },
        { title: '江西工业职业技术学院' },
        { title: '江西工业贸易职业技术学院' },
        { title: '江西工程技工学校' },
        { title: '江西工艺美术馆' },
        { title: '江西师范大学' },
        { title: '江西师范大学附属中学' },
        { title: '江西干部学院' },
        { title: '江西广播电视发展中心' },
        { title: '江西广播电视学校' },
        { title: '江西广播电视报社' },
        { title: '江西应用技术职业学院' },
        { title: '江西康宁医院' },
        { title: '江西教育学院' },
        { title: '江西教育期刊社' },
        { title: '江西教育电视台' },
        { title: '江西旅游商贸职业学院' },
        { title: '江西有色地质勘查局' },
        { title: '江西武夷山国家级自然保护区管理局' },
        { title: '江西江西省职业病防治研究院' },
        { title: '江西煤矿安全监察局' },
        { title: '江西煤矿抢险排水站' },
        { title: '江西环境工程职业学院' },
        { title: '江西理工大学' },
        { title: '江西生物科技职业学院' },
        { title: '江西电影制片厂' },
        { title: '江西电视台' },
        { title: '江西省万安县电影发行放映公司' },
        { title: '江西省不动产登记中心' },
        { title: '江西省专用通信局' },
        { title: '江西省世界自然遗产和风景名胜区管理中心' },
        { title: '江西省个协办' },
        { title: '江西省中医药研究院' },
        { title: '江西省中华会计函授学校' },
        { title: '江西省中华职业教育社秘书处' },
        { title: '江西省中小企业局' },
        { title: '江西省中小企业局机关后勤服务中心' },
        { title: '江西省中小企业服务中心' },
        { title: '江西省九江航空运动学校' },
        { title: '江西省交通医院' },
        { title: '江西省交通工会' },
        { title: '江西省交通工会委员会' },
        { title: '江西省交通工程监理咨询中心' },
        { title: '江西省交通工程质量监督站' },
        { title: '江西省交通干部学校' },
        { title: '江西省交通干部学院' },
        { title: '江西省交通科学研究院' },
        { title: '江西省交通运输厅' },
        { title: '江西省京剧团' },
        { title: '江西省人体器官捐献管理中心' },
        { title: '江西省人大信息保障中心' },
        { title: '江西省人工影响天气领导小组办公室' },
        { title: '江西省人民医院' },
        { title: '江西省人民检察院南昌铁路运输分院' },
        { title: '江西省人防工程设计科研院' },
        { title: '江西省会计培训中心' },
        { title: '江西省住房公积金管理中心' },
        { title: '江西省体育医院' },
        { title: '江西省体育总会' },
        { title: '江西省体育运动学校' },
        { title: '江西省体育馆' },
        { title: '江西省保密技术检查中心' },
        { title: '江西省信息中心' },
        { title: '江西省假肢中心' },
        { title: '江西省健康教育与促进中心' },
        { title: '江西省健康教育所' },
        { title: '江西省儿童医院' },
        { title: '江西省党内法规研究中心' },
        { title: '江西省公安厅' },
        { title: '江西省公安厅信息中心' },
        { title: '江西省公安厅机关后勤服务中心' },
        { title: '江西省公路局物资储运总站' },
        { title: '江西省公路工程监理公司' },
        { title: '江西省公路机械工程局' },
        { title: '江西省公路桥梁工程局' },
        { title: '江西省公路科研设计院' },
        { title: '江西省公路管理局交通通信总站' },
        { title: '江西省公路管理局信息数据中心' },
        { title: '江西省公路管理局机关后勤服务中心' },
        { title: '江西省公路运输管理局后勤服务中心' },
        { title: '江西省军民融合研究院' },
        { title: '江西省军队离休退休干部活动中心' },
        { title: '江西省农业厅农业项目管理办公室' },
        { title: '江西省农业技术机械技术推广监测站' },
        { title: '江西省农业机械研究所' },
        { title: '江西省农业气象中心' },
        { title: '江西省农业环境监测站' },
        { title: '江西省农科院' },
        { title: '江西省劳动教养管理局' },
        { title: '江西省化学工业学校' },
        { title: '江西省化学工业研究所' },
        { title: '江西省化工技校' },
        { title: '江西省化工设计院' },
        { title: '江西省医学会办公室' },
        { title: '江西省医学科学院' },
        { title: '江西省医药设计院' },
        { title: '江西省华侨文化交流中心' },
        { title: '江西省南方林业产权交易所' },
        { title: '江西省南昌城市建设学校' },
        { title: '江西省博物馆' },
        { title: '江西省发展和改革委员会' },
        { title: '江西省司法厅' },
        { title: '江西省司法厅机关后勤服务中心' },
        { title: '江西省司法警官职业学校' },
        { title: '江西省商业科学研究所' },
        { title: '江西省商务厅' },
        { title: '江西省固体废物管理中心' },
        { title: '江西省国土资源厅机关后勤服务中心' },
        { title: '江西省国家安全厅' },
        { title: '江西省国资委' },
        { title: '江西省国防工业设计院' },
        { title: '江西省国防科技情报研究所' },
        { title: '江西省国际交流外事服务中心' },
        { title: '江西省土地勘测规划院' },
        { title: '江西省土壤肥料技术推广站' },
        { title: '江西省地矿工程质量监测中心' },
        { title: '江西省地矿测绘院' },
        { title: '江西省地矿资产运营管理中心' },
        { title: '江西省地税局' },
        { title: '江西省地质环境监测总站' },
        { title: '江西省地质矿产勘查开发局信息中心' },
        { title: '江西省基础测绘院' },
        { title: '江西省天然林保护工程管理中心' },
        { title: '江西省妇女联合会' },
        { title: '江西省妇幼保健院' },
        { title: '江西省妇联所妇女研究所' },
        { title: '江西省委党校' },
        { title: '江西省委办公厅' },
        { title: '江西省委省政府接待办公室后勤中心' },
        { title: '江西省安全科学研究院' },
        { title: '江西省宗教院校教育服务中心' },
        { title: '江西省寄生虫病防治研究所' },
        { title: '江西省对外经济联络办公室' },
        { title: '江西省工业和信息化发展研究中心' },
        { title: '江西省工业和信息化委员会' },
        { title: '江西省工业经济协会' },
        { title: '江西省工人疗养院' },
        { title: '江西省工商信息中心' },
        { title: '江西省工商局' },
        { title: '江西省工商局机关后勤服务中心' },
        { title: '江西省工商行政管理学校' },
        { title: '江西省工程学院' },
        { title: '江西省工艺美术研究所' },
        { title: '江西省广告协会办' },
        { title: '江西省广播电视服务公司' },
        { title: '江西省广电局网络中心' },
        { title: '江西省庐山疗养院' },
        { title: '江西省建材科研设计院' },
        { title: '江西省建筑科学研究院' },
        { title: '江西省建设信息中心' },
        { title: '江西省建设培训中心' },
        { title: '江西省建设职业技术学院' },
        { title: '江西省总工会' },
        { title: '江西省总工会干部学校' },
        { title: '江西省总工会机关后勤服务中心' },
        { title: '江西省慈善总会' },
        { title: '江西省戒毒管理局中转站' },
        { title: '江西省扶贫办' },
        { title: '江西省护理职业技术学院' },
        { title: '江西省政务服务中心' },
        { title: '江西省政协光华时报社' },
        { title: '江西省政协干部培训中心' },
        { title: '江西省政协机关事务管理局' },
        { title: '江西省教育工程技术中心' },
        { title: '江西省教育考试院' },
        { title: '江西省文化厅机关后勤服务中心' },
        { title: '江西省文物保护中心' },
        { title: '江西省文联' },
        { title: '江西省新闻出版广电信息中心' },
        { title: '江西省新闻出版社学院' },
        { title: '江西省方志馆' },
        { title: '江西省木偶剧团' },
        { title: '江西省机关事务管理局' },
        { title: '江西省机械工业情报所' },
        { title: '江西省机械工业设计研究院' },
        { title: '江西省机械科学研究所' },
        { title: '江西省机械行管办' },
        { title: '江西省机械高级技工学校' },
        { title: '江西省林业人才服务中心' },
        { title: '江西省林业厅' },
        { title: '江西省林业厅信息中心' },
        { title: '江西省林业科学院' },
        { title: '江西省林业科技实验中心' },
        { title: '江西省林木育种中心' },
        { title: '江西省标准化研究院' },
        { title: '江西省核工业地质局' },
        { title: '江西省核工业地质局信息通讯中心' },
        { title: '江西省核工业地质局培训中心' },
        { title: '江西省核工业地质局机关后勤服务中心' },
        { title: '江西省核工业地质局档案馆' },
        { title: '江西省森林防火预警监测中心' },
        { title: '江西省残疾人体育管理中心' },
        { title: '江西省残联' },
        { title: '江西省民政厅' },
        { title: '江西省民政厅机关后勤服务中心' },
        { title: '江西省民政学校' },
        { title: '江西省民营经济研究中心' },
        { title: '江西省气象灾害应急预警中心' },
        { title: '江西省水利工程技师学院' },
        { title: '江西省汽车销售技术服务总公司' },
        { title: '江西省法治政府研究中心' },
        { title: '江西省测绘培训中心' },
        { title: '江西省消费者协会办' },
        { title: '江西省潦河工程管理局' },
        { title: '江西省煤炭工业科学研究所' },
        { title: '江西省煤矿设计院' },
        { title: '江西省环保厅' },
        { title: '江西省现代职业技术学院' },
        { title: '江西省监狱管理局信息网络管理中心' },
        { title: '江西省监狱管理局机关后勤服务中心' },
        { title: '江西省直属机关建筑设计院' },
        { title: '江西省直文化系统保育院' },
        { title: '江西省社会主义学院' },
        { title: '江西省社会科学界联合会' },
        { title: '江西省福利彩票发行中心' },
        { title: '江西省科技交流中心' },
        { title: '江西省科技金融管理服务中心' },
        { title: '江西省税务干部培训中心' },
        { title: '江西省粮食局' },
        { title: '江西省红十字会' },
        { title: '江西省经济晚报社' },
        { title: '江西省统战宣传信息中心' },
        { title: '江西省统计局' },
        { title: '江西省编办后勤服务中心' },
        { title: '江西省羽绒制品质量监督检验中心' },
        { title: '江西省考古研究所' },
        { title: '江西省职工对外交流中心' },
        { title: '江西省肿瘤医院' },
        { title: '江西省胸科医院' },
        { title: '江西省自动化能源监测中心' },
        { title: '江西省艺术档案馆' },
        { title: '江西省艺术研究院' },
        { title: '江西省节能监察总队' },
        { title: '江西省节能监察总队' },
        { title: '江西省节能监察总队' },
        { title: '江西省花炮质量监督检验站' },
        { title: '江西省药品不良反应监测中心' },
        { title: '江西省药品审评中心' },
        { title: '江西省药品检验检测研究院' },
        { title: '江西省药监局' },
        { title: '江西省药监局机关后勤服务中心' },
        { title: '江西省血液中心' },
        { title: '江西省袁惠渠工程管理局' },
        { title: '江西省话剧团' },
        { title: '江西省财政厅' },
        { title: '江西省财政厅政策研究室' },
        { title: '江西省财政投资管理中心' },
        { title: '江西省财经职业学院' },
        { title: '江西省质监局' },
        { title: '江西省质量技术监督局机关后勤服务中心' },
        { title: '江西省赣剧院' },
        { title: '江西省轻工业研究所' },
        { title: '江西省轻工业设计院' },
        { title: '江西省轻工业高级技工学校' },
        { title: '江西省通信应急技术支撑中心' },
        { title: '江西省通用技术工程学校' },
        { title: '江西省遥感信息系统中心' },
        { title: '江西省鄱阳湖生态经济区规划馆' },
        { title: '江西省金融发展服务中心' },
        { title: '江西省钨与稀土产品质量监督检验中心' },
        { title: '江西省陶瓷工艺美术职业技术学院' },
        { title: '江西省陶瓷知识产权信息中心' },
        { title: '江西省青年互联网信息中心' },
        { title: '江西省青年职业学院' },
        { title: '江西省革命烈士纪念堂' },
        { title: '江西省食品检验检测研究院' },
        { title: '江西省高速公路联网收费结算管理中心' },
        { title: '江西科技师范大学' },
        { title: '江西科普期刊社' },
        { title: '江西经济管理干部学院' },
        { title: '江西绿色生态葛研究所' },
        { title: '江西艺术中心' },
        { title: '江西艺术职业学院' },
        { title: '江西警察学院综合服务中心' },
        { title: '江西财经大学' },
        { title: '江西音像出版社' },
        { title: '江西马头山国家级自然保护区管理局' },
        { title: '江西高校出版社' },
        { title: '万安县乡镇敬老院' },
        { title: '万安县五丰镇人民政府' },
        { title: '万安县五丰镇棉津卫生院' },
        { title: '万安县五云林场' },
        { title: '万安县交通工程质量监督管理站' },
        { title: '万安县人大常委会办公室信访接待中心' },
        { title: '万安县人民来访接待中心' },
        { title: '万安县住建局下属乡镇规划站' },
        { title: '万安县农垦管理局' },
        { title: '万安县商务局' },
        { title: '万安县地税局' },
        { title: '万安县夏造镇便民服务中心' },
        { title: '万安县宝山乡便民服务中心' },
        { title: '万安县工业园区中心小学' },
        { title: '万安县工业园区幼儿园' },
        { title: '万安县工业园区管理委员会' },
        { title: '万安县归国华侨联合会' },
        { title: '万安县房屋征收办公室' },
        { title: '万安县扶贫和移民办公室乡镇扶贫工作站' },
        { title: '万安县政府信息网络中心' },
        { title: '万安县新城区幼儿园' },
        { title: '万安县机关事务管理局' },
        { title: '万安县枧头镇人民政府' },
        { title: '万安县残疾人康复就业服务中心' },
        { title: '万安县民兵训练基地' },
        { title: '万安县涧田乡人民政府' },
        { title: '万安县潞田镇便民服务中心' },
        { title: '万安县物流产业发展办公室' },
        { title: '万安县窑头镇便民服务中心' },
        { title: '万安县第二保育院' },
        { title: '万安县粮食局行政执法大队' },
        { title: '万安县红十字会' },
        { title: '万安县统计局乡镇统计站' },
        { title: '万安县老年大学' },
        { title: '万安县质量技术监督局' },
        { title: '万安县退役军人服务中心' },
        { title: '万安县金融办公室' },
        { title: '万安县防震减灾局' },
        { title: '万安县高陂镇便民服务中心' },
        { title: '万安县高陂镇综合执法局' },
        { title: '万年县地方税务局' },
        { title: '万载县地方税务局' },
        { title: '上犹县地方税务局' },
        { title: '上饶县地方税务局' },
        { title: '上饶市地方税务局' },
        { title: '上高县地方税务局' },
        { title: '东乡县地税局' },
        { title: '东华理工大学' },
        { title: '东湖区地方税务局' },
        { title: '中共万安县委民声通道工作室' },
        { title: '中共万安县委维护稳定工作领导小组办公室' },
        { title: '中共横峰县委信访局' },
        { title: '中共横峰县委办公室' },
        { title: '中共横峰县委宣传部' },
        { title: '中共横峰县委横峰县人民政府接待事务办公室' },
        { title: '中共横峰县委横峰县人民政府电子政务办公室' },
        { title: '中共横峰县委组织部' },
        { title: '中共江西省委农村工作部' },
        { title: '中共江西省委政策研究室' },
        { title: '中共江西省委机关事务管理局' },
        { title: '中共江西省委机要通信技术服务中心' },
        { title: '中共江西省委统一战线工作部机关后勤服务中心' },
        { title: '中共江西省直机关工委党校' },
        { title: '中国共产党横峰县纪律检查委员会' },
        { title: '丰城市地方税务局' },
        { title: '临川区地税局' },
        { title: '乐安县地税局' },
        { title: '乐平市地税局' },
        { title: '于都县地方税务局' },
        { title: '井冈山大学' },
        { title: '井冈山大学附属医院' },
        { title: '井冈山市地税局' },
        { title: '会昌县地方税务局' },
        { title: '余干县农业局' },
        { title: '余干县地方税务局' },
        { title: '余干县妇幼保健院' },
        { title: '余干县总工会' },
        { title: '余干县民政局' },
        { title: '余干县水利局' },
        { title: '余干县海尔希望学校' },
        { title: '余干县环保局' },
        { title: '余干县疾控中心' },
        { title: '余干县科技局' },
        { title: '余干县统计局' },
        { title: '余干县血防站' },
        { title: '余干县计生委' },
        { title: '余干县财政局' },
        { title: '余江县地税局' },
        { title: '信丰县地方税务局' },
        { title: '信州区地方税务局' },
        { title: '水县地方税务局' },
        { title: '全南地税' },
        { title: '共青团江西省委机关后勤服务中心' },
        { title: '兴国县地方税务局' },
        { title: '分宜县地方税务局' },
        { title: '华东交通大学' },
        { title: '南丰县地税局' },
        { title: '南城县地税局' },
        { title: '南康市地方税务局' },
        { title: '南昌县地方税务局' },
        { title: '南昌大学' },
        { title: '南昌大学第一附属医院' },
        { title: '南昌大学第二附属医院' },
        { title: '南昌大学人民武装学院' },
        { title: '南昌大学抚州医学分院' },
        { title: '南昌大学附属口腔医院' },
        { title: '南昌大学附属眼科医院' },
        { title: '南昌工程学院' },
        { title: '南昌市地方税务局' },
        { title: '南昌市地方税务局信息中心?' },
        { title: '南昌市地方税务局后勤中心' },
        { title: '南昌市航务分局' },
        { title: '南昌市铁路运输法院' },
        { title: '南昌市食品质量卫生安全监督检验中心' },
        { title: '南昌矿业权交易中心' },
        { title: '南昌航空大学' },
        { title: '南昌铁路运输中级人民法院' },
        { title: '南昌铁路运输检察院' },
        { title: '吉安县地税局' },
        { title: '吉安市人社局' },
        { title: '吉安市地方税务局' },
        { title: '吉州区人事局' },
        { title: '吉州区信访局' },
        { title: '吉州区农业局' },
        { title: '吉州区卫生局' },
        { title: '吉州区地税局' },
        { title: '吉州区教育局' },
        { title: '吉水县地税局' },
        { title: '大余县地方税务局' },
        { title: '奉新县地方税务局' },
        { title: '婺源县地方税务局' },
        { title: '宁都县地方税务局' },
        { title: '安义县地方税务局' },
        { title: '安福县地税局' },
        { title: '安远县地方税务局' },
        { title: '定南县地方税务局' },
        { title: '宜丰县地方税务局' },
        { title: '宜春市地方税务局' },
        { title: '宜黄县地税局' },
        { title: '寻乌县地方税务局' },
        { title: '峡江县地税局' },
        { title: '崇义县地方税务局' },
        { title: '崇仁县地税局' },
        { title: '广丰县地方税务局' },
        { title: '广昌县地税局' },
        { title: '庐山区地税局' },
        { title: '庐山风景区地税局' },
        { title: '弋阳县地方税务局' },
        { title: '彭泽县地税局' },
        { title: '德兴市地方税务局' },
        { title: '德安县地税局' },
        { title: '抚州市地方税务局' },
        { title: '抚州市高新区工商局' },
        { title: '新余市地方税务局' },
        { title: '新余市渝水区地税局' },
        { title: '新干县地税局' },
        { title: '新建县地方税务局' },
        { title: '昌江区地税局' },
        { title: '星子县地方税务局' },
        { title: '景德镇市地方税务局' },
        { title: '景德镇陶瓷学院' },
        { title: '樟树市地方税务局' },
        { title: '横峰中学' },
        { title: '横峰县上畈中学' },
        { title: '横峰县上畈卫生院' },
        { title: '横峰县中医院' },
        { title: '横峰县交通运输局' },
        { title: '横峰县人民代表大会常务委员会办公室' },
        { title: '横峰县人民医院' },
        { title: '横峰县人民政府办公室' },
        { title: '横峰县人民防空办公室' },
        { title: '横峰县保健院' },
        { title: '横峰县兴安学校' },
        { title: '横峰县农业农村局' },
        { title: '横峰县医疗保障局' },
        { title: '横峰县卫生监督所' },
        { title: '横峰县发展和改革委员会' },
        { title: '横峰县司法局' },
        { title: '横峰县司铺中学' },
        { title: '横峰县司铺卫生院' },
        { title: '横峰县商务局' },
        { title: '横峰县国土资源局' },
        { title: '横峰县地方税务局' },
        { title: '横峰县城市管理局' },
        { title: '横峰县姚家卫生院' },
        { title: '横峰县安全生产监督管理局' },
        { title: '横峰县审计局' },
        { title: '横峰县岑阳镇中心幼儿园' },
        { title: '横峰县工业和信息化局' },
        { title: '横峰县工信局' },
        { title: '横峰县市场物业管理服务中心' },
        { title: '横峰县市场监督管理局' },
        { title: '横峰县广播电视台' },
        { title: '横峰县建设局' },
        { title: '横峰县总工会' },
        { title: '横峰县扶贫办公室' },
        { title: '横峰县扶贫和移民办公室' },
        { title: '横峰县政协' },
        { title: '横峰县教育体育局' },
        { title: '横峰县文广新旅局' },
        { title: '横峰县新篁卫生院' },
        { title: '横峰县林业局' },
        { title: '横峰县档案局' },
        { title: '横峰县民政局' },
        { title: '横峰县气象局' },
        { title: '横峰县水利局' },
        { title: '横峰县港边卫生院' },
        { title: '横峰县环境保护局' },
        { title: '横峰县电商服务中心' },
        { title: '横峰县疾病预防控制中心' },
        { title: '横峰县皮肤性病防治所' },
        { title: '横峰县第三中学' },
        { title: '横峰县第二中学' },
        { title: '横峰县统计局' },
        { title: '横峰县莲荷中心卫生院' },
        { title: '横峰县葛源中学' },
        { title: '横峰县葛源中心卫生院' },
        { title: '横峰县行政服务中心' },
        { title: '横峰县财政局' },
        { title: '横峰县退役军人事务局' },
        { title: '横峰县铺前中心卫生院' },
        { title: '横峰县防震减灾局' },
        { title: '横峰县青板卫生院' },
        { title: '横峰县龙门畈乡卫生院' },
        { title: '横峰经济开发区管理委员会' },
        { title: '武宁县地税局' },
        { title: '永丰县地税局' },
        { title: '永新县地税局' },
        { title: '泰和县地税局' },
        { title: '浔阳区地税局' },
        { title: '浮梁县地税局' },
        { title: '湖口县地方税务局' },
        { title: '湾里区地方税务局' },
        { title: '玉山县地方税务局' },
        { title: '现代农业科技产业园区管理委员会' },
        { title: '珠山区地税局' },
        { title: '瑞昌地方税务局' },
        { title: '瑞金市地方税务局' },
        { title: '石城县地方税务局' },
        { title: '章贡区地方税务局' },
        { title: '萍乡市地方税务局' },
        { title: '萍乡市地方税务局上栗分局' },
        { title: '萍乡市地方税务局安源分局' },
        { title: '萍乡市地方税务局庐溪分局' },
        { title: '萍乡市地方税务局湘东分局' },
        { title: '萍乡市地方税务局莲花分局' },
        { title: '袁州区地方税务局' },
        { title: '西湖区地方税务局' },
        { title: '贵溪市地税局' },
        { title: '资溪县地税局' },
        { title: '赣南医学院' },
        { title: '赣南医学院第一附属医院' },
        { title: '赣南医学院第三附属医院' },
        { title: '赣南医学院第二附属医院' },
        { title: '赣县地方税务局' },
        { title: '赣州市地方税务局' },
        { title: '赣州市立医院' },
        { title: '赣州市章贡区东外街道东外社区卫生服务中心' },
        { title: '赣州市章贡区农业信息中心' },
        { title: '赣州市章贡区农村合作医疗管理中心' },
        { title: '赣州市章贡区区委党校' },
        { title: '赣州市章贡区南外社区服务中心' },
        { title: '赣州市章贡区卫生职业技术学校' },
        { title: '赣州市章贡区卫监所' },
        { title: '赣州市章贡区妇幼保健院' },
        { title: '赣州市章贡区就业局' },
        { title: '赣州市章贡区水东卫生院' },
        { title: '赣州市章贡区水利局' },
        { title: '赣州市章贡区疾控中心' },
        { title: '赣州市章贡区科技局' },
        { title: '赣州市章贡区行政服务中心管委会' },
        { title: '赣州市章贡区计划生育服务站' },
        { title: '赣州市章贡区赣江社区卫生服务中心' },
        { title: '赣江新区地方税务局' },
        { title: '进贤县地方税务局' },
        { title: '遂川县交通运输局' },
        { title: '遂川县人民医院' },
        { title: '遂川县人社局' },
        { title: '遂川县南北澳陂水利工程管理站' },
        { title: '遂川县博物馆' },
        { title: '遂川县发展和改革委员会' },
        { title: '遂川县国资总公司' },
        { title: '遂川县图书馆' },
        { title: '遂川县地税局' },
        { title: '遂川县城市管理综合执法局' },
        { title: '遂川县城投公司' },
        { title: '遂川县文广新局' },
        { title: '遂川县民政局' },
        { title: '遂川县狗牯脑茶文化传承中心' },
        { title: '遂川县行政服务中心' },
        { title: '遂川县财政局' },
        { title: '都昌县地方税务局' },
        { title: '鄱阳县地方税务局' },
        { title: '金溪县地税局' },
        { title: '铅山县地方税务局' },
        { title: '铜鼓县地方税务局' },
        { title: '青云谱区地方税务局' },
        { title: '青原区中小企业局' },
        { title: '青原区人社局' },
        { title: '青原区图书馆' },
        { title: '青原区地税局' },
        { title: '青原区就业局' },
        { title: '青原区文化馆' },
        { title: '青原区监察局' },
        { title: '青原区社保局' },
        { title: '青山湖区地方税务局' },
        { title: '靖安县地方税务局' },
        { title: '高安市地方税务局' },
        { title: '鹰潭市地方税务局' },
        { title: '鹰潭市月湖区地税局' },
        { title: '黎川县地税局' },
        { title: '龙南县地方税务局' },
        { title: '南矶乡人民政府' },
        { title: '原州区人社局' },
        { title: '双湖特别区人社局' },
        { title: '双湖特别区农牧局' },
        { title: '双湖特别区卫生服务中心' },
        { title: '吉安市吉州区财政局' },
        { title: '吉安市吉水县第二中心幼儿园' },
        { title: '吉安市永新县公务用车管理中心' },
        { title: '吉隆县人社局' },
        { title: '吉隆县教育局' },
        { title: '同心县人社局' },
        { title: '同心县道路运输管理局' },
        { title: '吴忠市人社局' },
        { title: '吴忠市同心县人民医院' },
        { title: '嘉黎县人社局' },
        { title: '噶尔县人力资源和社会保障局' },
        { title: '固原市人社局' },
        { title: '地区中级人民法院' },
        { title: '城关区人社局' },
        { title: '墨竹工卡县医院' },
        { title: '大成国有资产管理公司' },
        { title: '宁夏专用通信局' },
        { title: '宁夏交通信息监控中心' },
        { title: '宁夏交通运输厅' },
        { title: '宁夏人大会议中心' },
        { title: '宁夏人民剧院' },
        { title: '宁夏人民政府机关事务管理局' },
        { title: '宁夏价格信息中心' },
        { title: '宁夏党委组织部' },
        { title: '宁夏公共资源交易管理局' },
        { title: '宁夏公安厅' },
        { title: '宁夏农林科学院' },
        { title: '宁夏农牧厅' },
        { title: '宁夏医科大学' },
        { title: '宁夏医科大学总医院' },
        { title: '宁夏司法厅' },
        { title: '宁夏商务厅' },
        { title: '宁夏回族自治区中医医院' },
        { title: '宁夏回族自治区中医药管理局' },
        { title: '宁夏回族自治区中卫沙坡头国家级自然保护区管理局' },
        { title: '宁夏回族自治区人民医院' },
        { title: '宁夏回族自治区人社厅' },
        { title: '宁夏回族自治区国营暖泉农场职工医院' },
        { title: '宁夏回族自治区第三人民医院' },
        { title: '宁夏回族自治区国营暖泉农场职工医院' },
        { title: '宁夏回族自治区第五人民医院' },
        { title: '宁夏回族自治区职业教育园区管理委员会' },
        { title: '宁夏回族自治区艾依河管理局' },
        { title: '宁夏回族自治区质量技术监督局12365质量安全举报处置指挥中心' },
        { title: '宁夏回族自治区道路运输管理局' },
        { title: '宁夏回族自治区遥感测绘勘查院' },
        { title: '宁夏国土资源厅' },
        { title: '宁夏国家保密局' },
        { title: '宁夏国有资产监督管理委员会' },
        { title: '宁夏地方税务局' },
        { title: '宁夏地质局' },
        { title: '宁夏大学' },
        { title: '宁夏妇女联合会' },
        { title: '宁夏安全生产监督管理局' },
        { title: '宁夏审计厅' },
        { title: '宁夏工商职业技术学院' },
        { title: '宁夏水利厅' },
        { title: '宁夏水利电力工程学校' },
        { title: '宁夏水利科学研究院' },
        { title: '宁夏物价局' },
        { title: '宁夏特殊教育学校' },
        { title: '宁夏特种设备检验检测院' },
        { title: '宁夏环境保护厅' },
        { title: '宁夏社会主义学院' },
        { title: '宁夏社会科学院' },
        { title: '宁夏种禽场' },
        { title: '宁夏科学技术协会' },
        { title: '宁夏科学技术厅' },
        { title: '宁夏科技馆' },
        { title: '宁夏精细化工基地管理委员会' },
        { title: '宁夏经济和信息化委员会' },
        { title: '宁夏统计局' },
        { title: '宁夏老干部局' },
        { title: '宁夏老年人服务中心' },
        { title: '宁夏职业技术学院' },
        { title: '宁夏职工科技教育文化活动中心' },
        { title: '宁夏艺术职业学院' },
        { title: '宁夏葡萄酒与防沙治沙职业技术学院' },
        { title: '宁夏警官职业学院' },
        { title: '宁夏财政厅' },
        { title: '宁夏财经职业技术学院' },
        { title: '宁夏质量技术监督局' },
        { title: '宁夏食品药品监督管理局' },
        { title: '安义县中医院' },
        { title: '安义县财政局' },
        { title: '安多县人社局' },
        { title: '宜春市上高县商务局' },
        { title: '察雅县人力资源和社会保障局' },
        { title: '察雅县人民医院' },
        { title: '尼木县农牧局' },
        { title: '尼木县医院' },
        { title: '山南地区交通运输局' },
        { title: '山南地区交通运输局检测站' },
        { title: '山南地区人力资源和社会保障局' },
        { title: '山南地区人民医院' },
        { title: '山南地区住房和城乡建设局' },
        { title: '山南地区广电局' },
        { title: '山南地区教体局' },
        { title: '山南地区文化局' },
        { title: '山南地区林业局' },
        { title: '山南地区民政局' },
        { title: '岳阳职业技术学院附属医院' },
        { title: '崇仁县中医院' },
        { title: '崇仁县人民医院' },
        { title: '崇仁县农业局' },
        { title: '崇仁县畜牧水产局' },
        { title: '崇仁县疾控中心' },
        { title: '崇仁县相山医院' },
        { title: '崇仁县相山镇政府' },
        { title: '崇仁县石庄乡政府' },
        { title: '崇仁县社会保险事业管理局' },
        { title: '崇仁县马鞍镇政府' },
        { title: '崇仁许坊乡政府' },
        { title: '左贡县人力资源和社会保障局' },
        { title: '左贡县人民医院' },
        { title: '左贡县农牧局' },
        { title: '左贡县卫生局' },
        { title: '左贡县文化广播电影电视局' },
        { title: '左贡县水利局' },
        { title: '巴青县人社局' },
        { title: '巴青县农牧局' },
        { title: '巴青县广电局' },
        { title: '巴青县教体局' },
        { title: '巴青县文化局' },
        { title: '平罗县人社局' },
        { title: '康马县人社局' },
        { title: '当雄县人社局' },
        { title: '当雄县农牧局' },
        { title: '当雄县医院' },
        { title: '当雄县卫生局' },
        { title: '当雄县教体局' },
        { title: '当雄县文广局' },
        { title: '彭阳县人社局' },
        { title: '惠农区人社局' },
        { title: '扎囊县交通局' },
        { title: '扎囊县人民医院' },
        { title: '扎囊县人社局' },
        { title: '扎囊县卫生局' },
        { title: '扎囊县教育局' },
        { title: '拉萨市人力资源和社会保障局' },
        { title: '拉萨市人民医院' },
        { title: '拉萨市民政局' },
        { title: '拉萨市水利局' },
        { title: '拉萨市纪律检查委员会' },
        { title: '拉萨市环境卫生管理局' },
        { title: '拉萨市电影公司' },
        { title: '拉萨市电视台' },
        { title: '拉萨市科学技术局' },
        { title: '拉萨市自来水公司' },
        { title: '拉萨市计生委' },
        { title: '拉萨市设计院' },
        { title: '拉萨市质监站' },
        { title: '拉萨市质量技术监督局' },
        { title: '拉萨市食品药品监督管理局' },
        { title: '拉萨晚报社' },
        { title: '措勤县人力资源和社会保障局' },
        { title: '措美县人民医院' },
        { title: '措美县人社局' },
        { title: '日喀则地区人民医院' },
        { title: '日喀则地区人社局' },
        { title: '日喀则地区定结县人社局' },
        { title: '日喀则地区审计局' },
        { title: '日喀则地区工商行政管理局' },
        { title: '日喀则地区广电局' },
        { title: '日喀则地区报社' },
        { title: '日喀则地区教育局' },
        { title: '日喀则地区文化局' },
        { title: '日喀则地区林业局' },
        { title: '日喀则地区藏医院' },
        { title: '日喀则市人社局' },
        { title: '日土县电视台' },
        { title: '日土县社会保险管理局' },
        { title: '昌都县人力资源和社会保障局' },
        { title: '昌都地区人民医院' },
        { title: '昌都地区人社局' },
        { title: '昌都地区国土资源局' },
        { title: '昌都地区江达县人社局' },
        { title: '昌都地区职业技术学校' },
        { title: '昌都地区藏医院' },
        { title: '昌都地区财政局' },
        { title: '昌都地区质量技术监督局' },
        { title: '普兰县人力资源和社会保障局' },
        { title: '曲松县人民医院' },
        { title: '曲松县人社局' },
        { title: '曲松县农牧局' },
        { title: '曲松县卫生局' },
        { title: '曲水县人社局' },
        { title: '曲水县农牧局' },
        { title: '曲水县医院' },
        { title: '札达县人力资源和社会保障局' },
        { title: '札达县卫生局' },
        { title: '林周县人社局' },
        { title: '林芝地区人民医院' },
        { title: '林芝地区人社局' },
        { title: '林芝地区住建局' },
        { title: '林芝地区图书馆' },
        { title: '江孜县人民医院' },
        { title: '江孜县人社局' },
        { title: '江西广播电视台' },
        { title: '江西日报社' },
        { title: '江西省人力资源和社会保障厅' },
        { title: '江西省人大常委会办公厅' },
        { title: '江西省人民政府办公厅' },
        { title: '江西省人民检察院' },
        { title: '江西省人民防空办公室' },
        { title: '江西省住房和城乡建设厅' },
        { title: '江西省公安厅' },
        { title: '江西省农业厅' },
        { title: '江西省农业科学院' },
        { title: '江西省司法厅' },
        { title: '江西省商务厅' },
        { title: '江西省国土资源厅' },
        { title: '江西省国家保密局' },
        { title: '江西省安义县人民医院' },
        { title: '江西省审计厅' },
        { title: '江西省教育厅' },
        { title: '江西省文化厅' },
        { title: '江西省林业厅' },
        { title: '江西省档案局' },
        { title: '江西省森林公安局' },
        { title: '江西省气象局' },
        { title: '江西省水利厅' },
        { title: '江西省社会主义学院' },
        { title: '江西省社会科学院' },
        { title: '江西省科学技术协会' },
        { title: '江西省科学技术厅' },
        { title: '江西省科学院' },
        { title: '江西经济管理干部学院' },
        { title: '江达县农牧局' },
        { title: '江达县卫生局' },
        { title: '沙坡头区人社局' },
        { title: '泾源县人社局' },
        { title: '洛扎县人民医院' },
        { title: '洛扎县人社局' },
        { title: '洛扎县卫生局' },
        { title: '洛隆县人力资源和社会保障局' },
        { title: '洛隆县农牧局' },
        { title: '洛隆县教育局' },
        { title: '洛隆县文化广播电影电视局' },
        { title: '海南兴隆红十字医院' },
        { title: '海南医学院' },
        { title: '海南师范大学' },
        { title: '海南广播电视总台' },
        { title: '海南府城广播发射台' },
        { title: '海南政法职业学院' },
        { title: '海南省中医院' },
        { title: '海南省交通厅' },
        { title: '海南省交通厅交通规费征稽局' },
        { title: '海南省交通学校' },
        { title: '海南省人民医院' },
        { title: '海南省人社厅' },
        { title: '海南省住建厅' },
        { title: '海南省公安厅' },
        { title: '海南省公安厅安康医院' },
        { title: '海南省农业科学院' },
        { title: '海南省博物馆' },
        { title: '海南省卫生厅' },
        { title: '海南省司法厅' },
        { title: '海南省商务厅' },
        { title: '海南省图书馆' },
        { title: '海南省地方税务局' },
        { title: '海南省地质医院' },
        { title: '海南省地质局' },
        { title: '海南省外国语职业学院' },
        { title: '海南省安宁医院' },
        { title: '海南省平山医院' },
        { title: '海南省检察院' },
        { title: '海南省民政厅' },
        { title: '海南省水利灌区管理局' },
        { title: '海南省水务厅' },
        { title: '海南省海洋与渔业厅' },
        { title: '海南省眼科医院' },
        { title: '海南省财政厅' },
        { title: '海南省食药监局' },
        { title: '海南省高级人民法院' },
        { title: '海南软件职业技术学院' },
        { title: '海原县人社局' },
        { title: '灵武市人社局' },
        { title: '玉树市人社局' },
        { title: '玉树市八一医院' },
        { title: '玉树市疾病预防控制中心' },
        { title: '珠市学校教育集团' },
        { title: '班戈县人社局' },
        { title: '琼州学院' },
        { title: '琼结县人民医院' },
        { title: '琼结县人社局' },
        { title: '申扎县人社局' },
        { title: '申扎县农牧局' },
        { title: '申扎县卫生局' },
        { title: '白朗县人社局' },
        { title: '白朗县农牧局' },
        { title: '白朗县卫生局' },
        { title: '白朗县教育局' },
        { title: '白朗县文广局' },
        { title: '白朗县水利局' },
        { title: '盐池县人社局' },
        { title: '石嘴山市人社局' },
        { title: '石嘴山市卫计局' },
        { title: '石嘴山市地税局' },
        { title: '石嘴山市第一人民医院' },
        { title: '石城县人民医院' },
        { title: '类乌齐县人力资源和社会保障局' },
        { title: '类乌齐县人民医院' },
        { title: '索县人社局' },
        { title: '聂荣县人社局' },
        { title: '聂荣县农牧局' },
        { title: '聂荣县卫生局' },
        { title: '自治区宁东医院' },
        { title: '自治区旅游局' },
        { title: '芒康县人力资源和社会保障局' },
        { title: '萨嘎县人社局' },
        { title: '萨嘎县卫生局' },
        { title: '萨嘎县教育局' },
        { title: '萨迦县人社局' },
        { title: '萨迦县农牧局' },
        { title: '萨迦县卫生局' },
        { title: '萨迦县教育局' },
        { title: '萨迦县文广局' },
        { title: '西吉县人社局' },
        { title: '西吉县震湖乡人民政府' },
        { title: '西夏区人社局' },
        { title: '西夏区北区地税局' },
        { title: '西宁市世纪职业技术学校' },
        { title: '西宁市中医院' },
        { title: '西宁市产权交易市场' },
        { title: '西宁市人事局' },
        { title: '西宁市住房保障和房产管理局' },
        { title: '西宁市卫生局' },
        { title: '西宁市口腔医院' },
        { title: '西宁市司法局' },
        { title: '西宁市商务局' },
        { title: '西宁市国土资源局' },
        { title: '西宁市第一人民医院' },
        { title: '西宁市第一职业技术学校' },
        { title: '西宁市第三人民医院' },
        { title: '西宁市第二人民医院' },
        { title: '西宁市财政局' },
        { title: '西藏大学' },
        { title: '西藏日报社' },
        { title: '西藏电视台' },
        { title: '西藏职业技术学院' },
        { title: '西藏自治区国资委' },
        { title: '西藏自治区第二人民医院' },
        { title: '西藏藏医学院' },
        { title: '谢通门县人社局' },
        { title: '谢通门县农牧局' },
        { title: '谢通门县卫生局' },
        { title: '谢通门县教育局' },
        { title: '贡嘎县人民医院' },
        { title: '贡嘎县人社局' },
        { title: '贡嘎县农牧局' },
        { title: '贡嘎县卫生局' },
        { title: '贡觉县人力资源和社会保障局' },
        { title: '贡觉县人民医院' },
        { title: '贺兰县人社局' },
        { title: '贺兰县第一人民医院' },
        { title: '赣州市上犹县人民医院' },
        { title: '赣州市上犹县发改委' },
        { title: '赣州市会昌县中医院' },
        { title: '赣州市信丰县中医院' },
        { title: '赣州市信丰县人民医院' },
        { title: '赣州市大余县财政局' },
        { title: '赣州市石城县财政局' },
        { title: '边坝县人力资源和社会保障局' },
        { title: '边坝县人民医院' },
        { title: '达孜县医院' },
        { title: '那曲县人社局' },
        { title: '那曲地区人民医院' },
        { title: '那曲地区人社局' },
        { title: '那曲地区财政局' },
        { title: '银川市中医医院' },
        { title: '银川市中小企业担保中心' },
        { title: '银川市人社局' },
        { title: '银川市公安局' },
        { title: '银川市国土资源局' },
        { title: '银川市地震局' },
        { title: '银川市妇幼保健院' },
        { title: '银川市民政局' },
        { title: '银川市水务局' },
        { title: '银川市环境保护局' },
        { title: '银川市第一人民医院' },
        { title: '银川市第三人民医院' },
        { title: '银川市第二人民医院' },
        { title: '银川市统计局' },
        { title: '银川市财政局' },
        { title: '银川市贺兰县地方税务局' },
        { title: '银川市贺兰县第一人民医院' },
        { title: '银川美术馆' },
        { title: '银川职业技术学院' },
        { title: '错那县人民医院' },
        { title: '错那县人社局' },
        { title: '阿里地区人力资源和社会保障局' },
        { title: '阿里地区人民医院' },
        { title: '阿里地区教育局' },
        { title: '阿里地区藏医院' },
        { title: '阿里地委党校' },
        { title: '隆子县人民医院' },
        { title: '隆德县人社局' },
        { title: '青海交通职业技术学院' },
        { title: '青海卫生职业技术学院' },
        { title: '青海大学' },
        { title: '青海大学附属医院' },
        { title: '青海师范大学' },
        { title: '青海广播电视台' },
        { title: '青海广播电视大学' },
        { title: '青海日报社' },
        { title: '青海民族大学' },
        { title: '青海省中医院' },
        { title: '青海省交通医院' },
        { title: '青海省交通厅' },
        { title: '青海省人民医院' },
        { title: '青海省人民武装学院' },
        { title: '青海省人社厅' },
        { title: '青海省体育局' },
        { title: '青海省信访局' },
        { title: '青海省公路局' },
        { title: '青海省博物馆' },
        { title: '青海省卫生厅' },
        { title: '青海省商务厅' },
        { title: '青海省国土规划研究院' },
        { title: '青海省国土资源博物馆' },
        { title: '青海省国土资源厅' },
        { title: '青海省图书馆' },
        { title: '青海省地税局' },
        { title: '青海省地震局' },
        { title: '青海省妇女儿童医院' },
        { title: '青海省审计厅' },
        { title: '青海省审计厅机关后勤服务中心' },
        { title: '青海省工业职业技术学校' },
        { title: '青海省工商局' },
        { title: '青海省广播电视局' },
        { title: '青海省康复医院' },
        { title: '青海省建筑职业技术学院' },
        { title: '青海省心脑血管专科医院' },
        { title: '青海省民政厅' },
        { title: '青海省水利厅' },
        { title: '青海省测绘局' },
        { title: '青海省环境保护厅' },
        { title: '青海省电化教育馆' },
        { title: '青海省畜牧兽医职业技术学院' },
        { title: '青海省监狱管理局中心医院' },
        { title: '青海省第三人民医院' },
        { title: '青海省第四人民医院' },
        { title: '青海省藏医药研究院' },
        { title: '青海省藏医院' },
        { title: '青海省藏语系佛学院' },
        { title: '青海省财政厅' },
        { title: '青海省质监局' },
        { title: '青海省重工业职业技术学校' },
        { title: '黎川县宏村镇人民政府' },
        { title: '黎川县财政局' },
      ],
      pageData: [],
    }
  },
  created() {
    this.getPageData()
  },
  methods: {
    getPageData() {
      // this.queryParam.total = this.dataList.length
      this.queryParam.total = 170
      let startIndex = (this.queryParam.page - 1) * this.queryParam.pageSize
      let endIndex = startIndex + this.queryParam.pageSize
      this.pageData = this.dataList.slice(startIndex, endIndex)
    },
    currentChange(v) {
      this.queryParam.page = v
      this.getPageData()
    },
    MouseOver(v) {
      this.typeActive = v.id
    },
    clickType(v) {
      this.typeActive = v.id
    },
  },
}
</script>
<style scoped lang="scss">
.banner {
  background: url(~@/assets/images/home/banner-case.jpg) no-repeat center;
}
</style>
